export default "__VITE_ASSET__Cfi2KX$N__"